import React, {useState, useEffect} from 'react';

import useConfiguratorData from '../../hooks/useConfiguratorData';

const CarGallery = () => {

    const { getSelectedModel, getSelectedVersion, getSelectedColor } = useConfiguratorData();

    const selectedModel = getSelectedModel();
    const selectedVersion = getSelectedVersion();
    const selectedColor = getSelectedColor();

    const [colorImages, setColorImages] = useState(null);
    const [selectedImage, setSelectedImage] = useState(null);

    useEffect(() => {
        initImages();
    }, [selectedColor])

    const initImages = () => {
        if (selectedColor) {
            let images = [];
            for (let i = 1; i <= 3; i++) {
                if (selectedColor["image_" + i]) {
                    images.push(selectedColor["image_" + i]);
                }
            }
            if (images.length) setSelectedImage(images[0]);
            else setSelectedImage(null);
            setColorImages(images);
        }
        else {
            setSelectedImage(null);
            setColorImages(null);
        }
    }

    return (
        <div className="car-gallery">
            <div className="car-gallery-container">
                <div className="gallery-header">
                    {selectedVersion.logo && <img src={selectedVersion.logo.url} alt={selectedVersion.logo.alt} />}
                    {selectedModel.model_page && <a href={selectedModel.model_page} target="_blank" className="link-arrow">Ver ficha del modelo<i className="icon chevron-strong"></i></a>}
                </div>
                {selectedImage &&
                    <div className="gallery-body">
                        <img className="selected-image" src={selectedImage.url} alt={selectedImage.alt} />
                        <div className="gallery-footer">
                            {colorImages.map((image, i) => (
                                <div className={"other-images " + (selectedImage.alt == image.alt ? "active" : "")} key={`image-${i}`} onClick={() => setSelectedImage(image)}>
                                    <img src={image.url} alt={image.alt} />
                                </div>
                            ))}
                        </div>
                    </div>
                }
            </div>
            <div className="main-features-container">
                {selectedVersion.main_features.map((feature, i) => (
                    <div className="item-feature" key={`feature-${feature.id}`}>
                        {feature.icon && <img src={feature.icon.url} alt={feature.icon.alt} />}
                        {feature.description && <span>{feature.description}</span>}
                    </div>
                ))}
            </div>
        </div>
    )
}

export default CarGallery;